import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

const toMoment = (value) => {
  if (!value) return moment();
  return moment.isMoment(value) ? value.clone() : moment(value);
};

const normalizeRange = (range = {}) => ({
  startDate: toMoment(range.startDate),
  endDate: toMoment(range.endDate),
});

export const DateRangePicker = ({
  initialDateRange,
  onChange,
  definedRanges = [],
  open = true,
  rangesPosition = "top",
}) => {
  const [range, setRange] = useState(normalizeRange(initialDateRange));
  const [selectingEnd, setSelectingEnd] = useState(false);

  useEffect(() => {
    setRange(normalizeRange(initialDateRange));
  }, [initialDateRange]);

  useEffect(() => {
    if (open) setSelectingEnd(false);
  }, [open]);

  const updateRange = (nextRange, source) => {
    const normalized = normalizeRange(nextRange);
    setRange(normalized);
    if (onChange) onChange(normalized, { source });
  };

  const onDateChange = (date) => {
    const selectedDate = toMoment(date);

    if (!selectingEnd) {
      updateRange(
        {
          startDate: selectedDate,
          endDate: selectedDate,
        },
        "start",
      );
      setSelectingEnd(true);
      return;
    }

    updateRange(
      {
        startDate: range.startDate,
        endDate: selectedDate,
      },
      "end",
    );
    setSelectingEnd(false);
  };

  if (!open) return null;

  const rootClassName =
    rangesPosition === "right"
      ? "custom-daterange custom-daterange--ranges-right"
      : "custom-daterange";

  return (
    <div className={rootClassName}>
      {definedRanges.length > 0 && (
        <div className="custom-daterange__ranges">
          {definedRanges.map((item, index) => (
            <button
              type="button"
              className="btn btn-light btn-sm mb-1 mr-1"
              key={index}
              onClick={() => {
                setSelectingEnd(false);
                updateRange(
                  {
                    startDate: item.startDate,
                    endDate: item.endDate,
                  },
                  "preset",
                );
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}

      <div className="custom-daterange__pickers">
        <div className="mb-2">
          <ReactDatePicker
            selected={toMoment(range.startDate)}
            onChange={onDateChange}
            selectsStart={!selectingEnd}
            selectsEnd={selectingEnd}
            startDate={toMoment(range.startDate)}
            endDate={toMoment(range.endDate)}
            minDate={selectingEnd ? toMoment(range.startDate) : undefined}
            allowSameDay
            inline
          />
        </div>
      </div>
    </div>
  );
};

export const DateRange = DateRangePicker;

export default DateRangePicker;
